import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import HHSectionPlaceholder from 'components/common/HHSectionPlaceholder'
import { selectSelectedTab } from 'data/customer/customerDetailsLocationsSelectors'
import { ACTIVE, PLACEHOLDER_TEXTS } from '../settings'

const NoLocations = () => {
  const selectedTab = useSelector(selectSelectedTab)

  return (
    <Box display="flex" alignItems="center" justifyContent="center" flex={1} p={2}>
      <HHSectionPlaceholder title={selectedTab === ACTIVE ? PLACEHOLDER_TEXTS.NO_LOCATIONS : PLACEHOLDER_TEXTS.NO_DEACTIVATED_LOCATIONS} />
    </Box>
  )
}

export default NoLocations
